import React from "react";
import {
  FaAndroid,
  FaCheckCircle,
  FaGlobe,
  FaRegChartBar,
  FaShoppingCart,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";
import { FaUser, FaTags, FaTruck } from "react-icons/fa";
import { MdPublic } from "react-icons/md";
import {
  BiPlusCircle,
  BiCheckCircle,
  BiXCircle,
  BiCalendar,
} from "react-icons/bi";
import { FaBox, FaClipboardList, FaWarehouse } from "react-icons/fa";
import { TagComponent } from "../Tabs";

const Reports = () => {


  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaRegChartBar className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Reports</h1>
      </div>


      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>


      <p className="text-start mb-6 text-gray-600 text-gray-300">
        Reports offer in-depth details covering almost every area of your Selzor
        account.
      </p>

      <div className="p-6 bg-white border border-gray-300 rounded-lg shadow-lg text-gray-800 text-sm space-y-10">
        {/* Report Criteria */}
        <section>
          <h2 className="text-lg text-start font-semibold mb-4">
            Report Criteria
          </h2>
          <ul className="border border-gray-200 rounded divide-y divide-gray-200">
            <li className="flex items-center gap-3 p-3">
              <FaClipboardList className="text-blue-600" /> <span>Orders</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <FaUsers className="text-blue-600" />{" "}
              <span>Buyer or Supplier</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <FaUser className="text-blue-600" /> <span>User</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <FaTags className="text-blue-600" /> <span>Category*</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <FaBox className="text-blue-600" /> <span>Product*</span>
            </li>

            <li className="flex items-center gap-3 p-3">
              <FaWarehouse className="text-blue-600" /> <span>Warehouse*</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <FaTruck className="text-blue-600" /> <span>Distributor*</span>
            </li>
          </ul>

          <div className="mt-4 bg-yellow-100 text-yellow-800 p-3 rounded text-start">
            *Exclusive to 'Seller' accounts. The 'Products' report can also be
            divided into specific 'Product Variations'.
          </div>
        </section>

        {/* Order Status */}
        <section>
          <h2 className="text-lg text-start font-semibold mb-3">
            Order Status
          </h2>
          <ul className="border border-gray-200 rounded divide-y divide-gray-200">
            <li className="flex items-center gap-3 p-3">
              <BiPlusCircle className="text-blue-600" /> <span>New</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <BiCheckCircle className="text-blue-600" /> <span>Complete</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <BiXCircle className="text-blue-600" /> <span>Cancelled</span>
            </li>
          </ul>
        </section>

        {/* Report Grouping */}
        <section>
          <h2 className="text-lg text-start font-semibold mb-4">
            Report Grouping
          </h2>
          <ul className="border border-gray-200 rounded divide-y divide-gray-200">
            <li className="flex items-center gap-3 p-3">
              <BiCalendar className="text-blue-600" /> <span>Date</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <BiCalendar className="text-blue-600" /> <span>Month</span>
            </li>
            <li className="flex items-center gap-3 p-3">
              <BiCalendar className="text-blue-600" /> <span>Year</span>
            </li>
          </ul>

          <p className="text-gray-600 text-start mt-3">
            Reports can be accessed for any selected date range, and the options
            mentioned above can be modified.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Reports;
